<template>
  <div class="page-content">
    <div class="priceTable-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/priceTable' }">{{ $locale("sideMenu.cinemaWebsite.priceTable.title") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $locale("cinemaWebsite.custom.dialog.title") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form
      class="egl-elm egl-detail"
      :model="form"
      :rules="formRules"
      ref="detailForm"
      label-position="top"
    >
      <el-col :span="24">
        <div class="form-module-tit">{{ $locale("cinemaWebsite.custom.dialog.title") }}</div>
      </el-col>
      <el-row>
        <el-col :span="10">
          <el-form-item
            :label="$locale('cinemaWebsite.priceTable.table.header.name')"
            prop="name"
          >
            <el-input
              :placeholder="$locale('cinemaWebsite.priceTable.dialog.form.name.plsInput')"
              v-model.number="form.name"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item
            :label="$locale('cinemaWebsite.custom.dialog.form.sort')"
            prop="sort"
          >
            <el-input
              v-model.number="form.sort"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item
            :label="$locale('cinemaWebsite.custom.table.header.description')"
            prop="description"
          >
            <el-input
              :placeholder="$locale('cinemaWebsite.priceTable.dialog.form.description.plsInput')"
              v-model="form.description"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item
            style="width:140px;"
            :label="$locale('cinemaWebsite.custom.table.header.price')"
            prop="price"
          >
            <el-input
              v-model.number="form.price"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
        <el-col :span="24" style="text-align: center;">
          <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
        </el-col>
      </el-row>
  </div>
</template>
<script>
import { createPriceTableService, updatePriceTableService, getPriceTableDetailService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      form: {
        name: "",
        sort: 0,
        description: "",
        price: 0,
      },
      formRules: {
        name: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.priceTable.dialog.form.title.required"),
            trigger: [ "blur" ]
          }
        ],
        sort: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.custom.dialog.form.sort.required"),
            trigger: [ "blur" ]
          }
        ],
        // description: [
        //   {
        //     required: true,
        //     message: this.$locale("cinemaWebsite.priceTable.dialog.form.description.required"),
        //     trigger: [ "blur" ]
        //   }
        // ],
        price: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.priceTable.dialog.form.price.required"),
            trigger: [ "blur" ]
          }
        ]
      },
      actionType: this.$route.path.indexOf("create") > -1 ? "create" : "edit"
    };
  },
  created() {
    if(this.$route.path.indexOf("update") > -1) {
      getPriceTableDetailService({ id: this.$route.params.id }).then(res => {
        this.form = res.data;
      });
    }
  },
  methods: {
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText,
        callback: () => {
          this.$router.push("/priceTable");
        }
      });
    },
    save_fn() {
      const requestParam = {
        ...this.form,
        cinemaId: window.localStorage.getItem("cinemaId"),
      };
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (this.actionType === "create") {
            createPriceTableService(requestParam).then(res => {
              /** 
               * data {} | null
               * 
              */
              this.requestScuessFn(res, this.$locale("global.createSuccessfully"));
            });
          } else {
            updatePriceTableService(requestParam).then(res => {
              this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    }
  }
};
</script>